// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Alert_wrapper__1F_Sn","block":"Alert_block__zgK_f","icon":"Alert_icon__owNBN","message":"Alert_message___lIc-"};